import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';
import styled from 'styled-components';

import { IEventStoreState } from '../../store/event/types';
import { UserEventItemV1 } from './userEventItemV1';
import { PopUp } from '../../store/animations';

type UserEventsListType = {
  events: Array<IEventStoreState>;
};

export const UserEventsListV1: FC<UserEventsListType> = ({ events }) => (
  <AnimatePresence>
    <EventsList variants={PopUp} initial={'enter'} animate={'exit'}>
      {events.map((event, index) => (
        <EventsListItem key={index}>
          <UserEventItemV1 event={event} />
        </EventsListItem>
      ))}
    </EventsList>
  </AnimatePresence>
);

const EventsList = styled(motion.ul)`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const EventsListItem = styled.li`
  margin-bottom: 10px;
`;
